const CheckIcon = ( { className } ) => {
	return (
		
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"
				 className={className}>
			<rect width="56" height="56" rx="16" fill="#85C553"/>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M28.0002 15.9999C21.3727 15.9999 16.0002 21.3725 16.0002 27.9999C16.0002 34.6273 21.3727 39.9999 28.0002 39.9999C34.6276 39.9999 40.0002 34.6273 40.0002 27.9999C40.0002 21.3725 34.6276 15.9999 28.0002 15.9999ZM13.3335 27.9999C13.3335 19.8997 19.9 13.3333 28.0002 13.3333C36.1003 13.3333 42.6668 19.8997 42.6668 27.9999C42.6668 36.1001 36.1003 42.6666 28.0002 42.6666C19.9 42.6666 13.3335 36.1001 13.3335 27.9999Z"
						fill="white"/>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M32.9426 24.3905C33.4633 24.9112 33.4633 25.7554 32.9426 26.2761L27.6093 31.6095C27.0886 32.1302 26.2444 32.1302 25.7237 31.6095L23.057 28.9428C22.5363 28.4221 22.5363 27.5779 23.057 27.0572C23.5777 26.5365 24.4219 26.5365 24.9426 27.0572L26.6665 28.781L31.057 24.3905C31.5777 23.8698 32.4219 23.8698 32.9426 24.3905Z"
						fill="white"/>
		</svg>
	
	);
};

export default CheckIcon;
